module.exports = __webpack_public_path__ + "img/group.68185beb.svg";